export default {
    querySafeList: '/gateway/manageBedrock/free/safecs/querySafeList', // 安全培训列表查询
}


// WEBPACK FOOTER //
// ./src/safetyTraining/index/api.js